import React from "react";
import BackButton from "@/note_office/shared/BackButton";
import translator from "@/translator";
import { Input, Button, Typography, Form, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import Helper from "@/helper";
import { useSubState } from "../State.js";

const t = translator("note_office.views.subscriptions.index_view.sms_form.");

const SmsForm = ({}) => {
  const { state } = useSubState();

  const navigate = useNavigate();

  const formMethods = useForm();
  const { register, setValue, getValues } = formMethods;

  const onSubmit = (_) => {
    const preparedFormData = getValues();
    return axios({
      method: "POST",
      data: preparedFormData,
      url: state.payment_url,
      headers: {
        "X-CSRF-TOKEN": Helper.getCSRFToken(),
      },
    }).then((response) => {
      const res_data = response.data;
      if (res_data.redirect_to) {
        window.location.href = res_data.redirect_to;
      }

      if (res_data.errors) {
        res_data.errors.map((error) => {
          message.error(error);
        });
      }
    });
  };

  register("gateway_type", { value: state.sms_form_params.gateway_type });
  register("payment_method", { value: state.sms_form_params.payment_method });
  register("payment_object", { value: state.sms_form_params.payment_object });
  register("sum", { value: 0 });

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <div className="subscriptions__recharge">
        <BackButton onClick={() => navigate("/")} title={t("title")} />

        <Typography.Text className="subscriptions__recharge-label">
          {t("amount_label")}
        </Typography.Text>
        <Typography.Paragraph className="subscriptions__recharge-description" type="secondary">
          {t("amount_description")}
        </Typography.Paragraph>

        <Form layout="vertical" onFinish={onSubmit} className="subscriptions__recharge-form">
          <Form.Item name="amount">
            <Input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              placeholder="10$"
              className="contacts-form__input"
              onChange={(e) => setValue("sum", e.target.value)}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block className="contacts-form__btn-primary">
              {t("submit")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SmsForm;
